import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  InputLabel,
  FormControl,
} from "@mui/material";
import { FieldWrapper } from "styles/formStyleComponents";

const DEFAULT_COLOR_OPTIONS = [
  { label: "Light Blue", value: "#008FD5" },
  { label: "Lime", value: "#827717" },
  { label: "Orange", value: "#D84315" },
  { label: "Pink", value: "#880E4F" },
  { label: "Purple", value: "#311B92" },
  { label: "Yellow", value: "#F9A825" },
];

const IconBackgroundSelectorFieldComponent = ({
  name,
  value,
  onChange,
  field,
}) => {
  const colorOptions = field?.colorOptions;
  const options = colorOptions || DEFAULT_COLOR_OPTIONS;
  const width = "95%";
  
  const getInitialColor = () => {
    if (value?.value && options.find(opt => opt.value === value.value)) {
      return value.value;
    }
    return options[0]?.value || "";
  };
  const [selectedColor, setSelectedColor] = useState(getInitialColor());
  const hasAutoSelectedRef = React.useRef(false);
  const labelId = `icon-background-label-${name}`;
  
  // Auto-select default color on mount if no value is set
  useEffect(() => {
    const hasValue = value && (
      (typeof value === 'object' && value.value) || 
      (typeof value === 'string' && value.trim())
    );
    
    if (!hasValue && !hasAutoSelectedRef.current && options[0]) {
      const defaultOption = options[0];
      setSelectedColor(defaultOption.value);
      hasAutoSelectedRef.current = true;
      onChange(name, defaultOption);
    } else if (value?.value && options.find(opt => opt.value === value.value)) {
      setSelectedColor(value.value);
      hasAutoSelectedRef.current = true;
    } else if (!value || (typeof value === 'object' && !value.value) || (typeof value === 'string' && !value.trim())) {
      if (options[0] && !hasAutoSelectedRef.current) {
        setSelectedColor(options[0].value);
      }
    } else if (value?.value && !options.find(opt => opt.value === value.value) && options[0]) {
      setSelectedColor(options[0].value);
    }
  }, [colorOptions, value, options, name]);

  return (
    <FieldWrapper>
      <Box sx={{ width: width, justifySelf: "center" }}>
        <FormControl 
          fullWidth 
          size="small" 
          variant="outlined"
          sx={{
            '& .MuiFormHelperText-root': {
              marginLeft: 0
            }
          }}
        >
          <InputLabel id={labelId}>Icon Background</InputLabel>
          <Select
            labelId={labelId}
            label="Icon Background"
            value={selectedColor}
            onChange={(e) => {
              setSelectedColor(e.target.value);
              const selectedOption = options.find(el => el.value === e.target.value);
              onChange(name, selectedOption || null);
            }}
            renderValue={(value) => {
              const option = options.find((c) => c.value === value);
              if (!option) return null;
              return (
                <Box display="flex" alignItems="center">
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      bgcolor: option.value,
                      borderRadius: "4px",
                      padding: "2px"
                    }}
                  />
                  <Typography p={1}>{option.label}</Typography>
                </Box>
              );
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <ListItemIcon>
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      bgcolor: option.value,
                      borderRadius: "4px",
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary={option.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </FieldWrapper>
  );
};

export { DEFAULT_COLOR_OPTIONS };
export default IconBackgroundSelectorFieldComponent;

